// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import moment from 'moment'
import config from './utils/config'
import base from './utils/base'
import request from './utils/request'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
import VueCropper from 'vue-cropper'
Vue.use(VueCropper);
import Print from 'vue-print-nb';
Vue.use(Print);
import * as echarts from 'echarts';
import Element from 'element-ui';

Vue.use(Element, {
    // size: 'medium',
    i18n: (key, value) => i18n.t(key, value)
})
// Vue.locale = () => {};

//css
// import 'element-ui/lib/theme-chalk/index.css';
// import './assets/css/element_theme/index.css';
import './assets/css/iview_icon.css'
import './assets/css/main.css'

//自定义全局组件
import myNav from './components/myNav.vue';
Vue.component('myNav',myNav)
import Icon from './components/Icon.vue';
Vue.component('Icon',Icon)
import myDrawer from './components/myDrawer.vue';
Vue.component('myDrawer',myDrawer)
import mySubTitle from './components/mySubTitle.vue';
Vue.component('mySubTitle',mySubTitle)
import myPage from './components/myPage.vue'
Vue.component('myPage',myPage)
import mySubPage from './components/mySubPage.vue';
Vue.component('mySubPage',mySubPage)

//语言包
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import twLocale from "element-ui/lib/locale/lang/zh-TW";
import enLocale from "element-ui/lib/locale/lang/en";
import cn from "./utils/lang/zh-CN";
import tw from "./utils/lang/zh-TW";
import en from "./utils/lang/en";

//语言包
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: base.getLang(),  // 语言标识
    messages : {
        'zh-CN': Object.assign(cn, zhLocale),
        'zh-TW': Object.assign(tw, twLocale),
        'en': Object.assign(en, enLocale)
    }
});

Vue.prototype.$moment = moment;
Vue.prototype.$config = config;
Vue.prototype.$base = base;
Vue.prototype.$request = request;
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false;
config.i18n = i18n;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>',

});



// WEBPACK FOOTER //
// ./src/main.js